import instance from './instance';

export const getMembers = () => instance.get('/api/v0/members');

export const updateMember = data => instance(`/api/v0/members/${data.member.id}`, { method: 'PUT', data });

export const destroyMember = memberId =>
  instance(`/api/v0/members/${memberId}`, {
    method: 'DELETE',
    data: { member: { id: memberId } },
  });
